/*
 SEE ALSO:
   bms-calculated-options2.js: Code for creating calculated options
   bms-sku-builder.js: Code for building & selecting SKUs using option selections
   bms-sku-builder-declarations.js: Declaring & using the SKU builder library defined above
   bms-3d-integration.js: Code for integrating Options with ClaraIO
*/

var BOLD = window.BOLD || {};
// Declare our functions...
BOLD.bms_custom_options = {
  hideHiddenOptions:function(evt){
    //Options with a public name beginning with an underscore shouldn't be visible
    var optProd = evt.data.option_product;
    for(var os=optProd.optionSets.length; os; os--){
      var optSet = optProd.optionSets[os-1];
      for(var o=optSet.options.length; o; o--){
        var option = optSet.options[o-1];
        if(option.publicName[0] === '_' && !BOLD.debugMode){
          option.DOM.element.style.display = 'none';
        }
      }
    }

  }
}

// Validate options as they are changed, not just when the submit is clicked.
// Wait a little while after the first failure before setting this up - make it so that we validate only if the user needs guidance afterwards
BOLD.common.eventEmitter.once('BOLD_OPTIONS_validation_failed', function(){
  BOLD.options.app.on('option_changed', function(evt){
    evt.data.option.validateOption()
  })
})

// And some misc. helper functions...
BOLD.helpers = BOLD.helpers || {}
BOLD.helpers.triggerEvent = function(event_name,additional_data,original_event){

  if(window.BOLD && BOLD.common && BOLD.common.eventEmitter){
    //Prefix 'BOLD_COMMON' scope if no (BOLD) scope is provided
    var bold_event_name = (event_name.indexOf('BOLD_') > -1 || event_name.indexOf('BMS') > -1 ? event_name : 'BOLD_COMMON_' + event_name);
    var eventData = {};
    if(original_event){
      eventData.original_event=original_event;
      if(original_event.target){
        eventData.target=original_event.target;
      }
    }
    if(additional_data){
      eventData.data = additional_data;
    }

    BOLD.common = BOLD.common || {};
    BOLD.common.settings = BOLD.common.settings || {};
    if(window.console && console.debug && (BOLD.common.settings.log_events || BOLD.common.settings.log_event_data || BOLD.debugMode)){
      //For browsers with console.debug, use the debug command to keep console output at the appropriate level
      console.debug('📡 EVENT TRIGGERED:', bold_event_name, (BOLD.common.settings.log_event_data || BOLD.debugMode) && eventData);
    }

    BOLD.common.eventEmitter.emit(bold_event_name, eventData);
  }
};

// And then run them when appropriate
if(BOLD.options && BOLD.options.app){
  BOLD.options.app.on('options_loaded', BOLD.bms_custom_options.hideHiddenOptions)
}
